/**
 * Cart drawer total: "Total incl. delivery" + Klarna 3-payment line.
 *
 * Permanent implementation of the winning "Side Cart bottom" test
 * (previously run via Intelligems). Replaces the native estimated-total row
 * inside the cart with a total that includes the delivery fee, plus a Klarna
 * instalment line.
 *
 * Shipping tiers: £5 under £100, £20 at or above £100 (matches cart-summary.liquid).
 */
(function () {
  var INJECTED_CLASS = 'cart-total-incl-delivery';

  var money = function (p) {
    return '£' + (p / 100).toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  var buildHtml = function (incl) {
    return '' +
      '<div class="' + INJECTED_CLASS + '" style="width:100%">' +
        '<div style="display:flex;justify-content:space-between;align-items:baseline">' +
          '<span class="cart-primary-typography" style="font-size:var(--cart-font-size--sm)">' +
            '<strong>Total</strong> <span style="opacity:.6">incl. delivery</span>' +
          '</span>' +
          '<span class="cart-secondary-typography" style="font-size:var(--cart-font-size--2xl);white-space:nowrap">' +
            money(incl) + ' GBP' +
          '</span>' +
        '</div>' +
        '<div style="display:flex;justify-content:flex-end;align-items:center;gap:.35em;margin-top:.25rem;font-size:var(--cart-font-size--2xs);opacity:.7">' +
          'or 3 &times; ' + money(Math.floor(incl / 3)) + ' with ' +
          '<span style="background:#ffb3c7;color:#0b051d;font-weight:700;padding:.2em .45em;border-radius:.25em">Klarna</span>' +
        '</div>' +
      '</div>';
  };

  var run = function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var incl = c.total_price + (c.total_price < 10000 ? 500 : 2000);
        var html = buildHtml(incl);

        document.querySelectorAll('.cart__ctas').forEach(function (cta) {
          var parent = cta.parentNode;
          if (!parent) return;

          // Remove any previously injected block so we don't duplicate.
          parent.querySelectorAll('.' + INJECTED_CLASS).forEach(function (el) {
            el.remove();
          });

          var original = parent.querySelector('.cart__total-container');
          if (original) {
            original.style.setProperty('display', 'none', 'important');
            original.insertAdjacentHTML('afterend', html);
          } else {
            cta.insertAdjacentHTML('beforebegin', html);
          }
        });
      })
      .catch(function () { /* swallow: leave native total in place on failure */ });
  };

  var init = function () {
    run();

    // The cart drawer re-renders its contents on add/update. Re-run whenever a
    // checkout CTA appears without our injected block next to it.
    new MutationObserver(function () {
      var needsRun = [].slice.call(document.querySelectorAll('.cart__ctas')).some(function (cta) {
        return cta.parentNode && !cta.parentNode.querySelector('.' + INJECTED_CLASS);
      });
      if (needsRun) run();
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
